import axios from 'axios'
import { BASE_URL, BASE_VIREED } from './base-url'
import VideoService from './video.service.js'

var base = BASE_URL;
var base_vireed = BASE_VIREED;


export default class chatService {

    getChatRoom(token, chatRoomId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatRooms/' + chatRoomId,
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    newMessage(token, message, chatRoomId) {
        var newMessage = JSON.stringify(message)
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/' + chatRoomId,
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: newMessage,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getMessages(token, page, pageSize, chatRoomId) {
        var pageInfo =
        {
            messagePage: page,
            messagesPerPage: pageSize,
        }

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/' + chatRoomId,
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                params: pageInfo,
            };

            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    uploadFile(token, file, chatRoomId, messageId) {

        var newFile = new FormData();
        newFile.append('file', file.blob, file.name);
        newFile.append('type', file.type);
        newFile.append('extension', file.extension);
        newFile.append('name', file.name);
        newFile.append('size', file.size);
        newFile.append('localUrl', file.localUrl);
        newFile.append('messageId', messageId)

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/file/' + chatRoomId,
                method: 'post',
                headers: {
                    'Content-Type': `multipart/form-data;boundary=${newFile._boundary}`,
                    'Authorization': 'Basic ' + token
                },
                data: newFile,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    addReaction(token, messageId, reactionName, roomId) {
        let body = JSON.stringify({
            reaction: reactionName,
            roomId: roomId,
        })
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/reaction/' + messageId,
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: body,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    removeReaction(token, messageId, reactionName, roomId) {
        let body = JSON.stringify({
            reaction: reactionName,
            roomId: roomId,
        })
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/reaction/' + messageId,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: body,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    updateSeenMessage(token, messageId, roomId) {
        let body = JSON.stringify({
            roomId: roomId,
        })
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/seen/' + messageId,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: body,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    editMessage(token, message, roomId, messageId) {
        var newMessage = JSON.stringify(message)
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/' + roomId + '/' + messageId,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: newMessage,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteMessage(token, messageId, roomId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatMessages/' + roomId + '/' + messageId,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getRooms(token, page, pageSize) {
        var pageInfo =
        {
            roomPage: page,
            roomsPerPage: pageSize,
        }

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatRooms/',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                params: pageInfo,
            };

            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getAllRooms(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/allChatRooms/',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };

            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getLastMessage(token, roomId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatRoom/' + roomId + '/lastMessage',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };

            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    checkPrivateConv(token, username) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatRoom/checkPrivate/' + username,
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };

            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    createPrivateConv(token, myUsername, OtherUsername) {
        var chatRoom = JSON.stringify({
            roomName: OtherUsername,
            users: [myUsername, OtherUsername],
        })

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/chatRooms',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: chatRoom,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    checkUnseenMessages(token)
    {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/checkUnseenMessages/',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };

            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

}